// src/components/rewards/rewards.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment UILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    accessibility\n    action {\n      ...UILinkActionFragment\n    }\n    disabled\n    primary\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment ActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n    }\n    target\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ...ActionFragment\n    }\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n    theme\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    id\n    theme\n    token\n    size\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...IconFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment RewardsTierCardsFragment on RetailTravelAgentTierCards {\n    id\n    token\n    background\n    infoIcon {\n      ...IconFragment\n    }\n    headingPoints {\n      ...EGDSStylizedTextFragment\n    }\n    descriptionPoints {\n      ...EGDSStylizedTextFragment\n    }\n    descriptionPointsValue {\n      ...EGDSStylizedTextFragment\n    }\n    redeemYourPointsButton {\n      ...EGDSButtonFragment\n    }\n    moreInfoPopOver {\n      heading\n      paragraph\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment RewardsEnrolledViewFragment on RetailTravelAgentRewardsResult {\n    icon {\n      ...IconFragment\n    }\n    heading {\n      ...EGDSStylizedTextFragment\n    }\n    paragraph {\n      ...EGDSStylizedTextFragment\n    }\n    refreshedAt {\n      ...EGDSStylizedTextFragment\n    }\n    inLineLink {\n      ...EGDSStandardLinkFragment\n    }\n    tierCards {\n      ...RewardsTierCardsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment RewardsNonEnrolledPopoverFragment on RetailTravelAgentRewardsResult {\n    justEnrolledButton {\n      ...EGDSButtonFragment\n    }\n    justEnrolledPopOver {\n      heading\n      paragraph\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment RewardsNonEnrolledViewFragment on RetailTravelAgentRewardsResult {\n    image {\n      description\n      url\n    }\n    heading {\n      ...EGDSStylizedTextFragment\n    }\n    paragraph {\n      ...EGDSStylizedTextFragment\n    }\n    refreshedAt {\n      ...EGDSStylizedTextFragment\n    }\n    inLineLink {\n      ...EGDSStandardLinkFragment\n    }\n    startEarningPointsButton {\n      ...EGDSButtonFragment\n    }\n    justEnrolledButton {\n      ...EGDSButtonFragment\n    }\n    justEnrolledPopOver {\n      heading\n      paragraph\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  query RewardsQuery($context: ContextInput!) {\n    retailTravelAgentRewards(context: $context) {\n      title\n      rewardsProgramState\n      image {\n        description\n        url\n      }\n      icon {\n        ...IconFragment\n      }\n      heading {\n        ...EGDSStylizedTextFragment\n      }\n      paragraph {\n        ...EGDSStylizedTextFragment\n      }\n      refreshedAt {\n        ...EGDSStylizedTextFragment\n      }\n      inLineLink {\n        ...EGDSStandardLinkFragment\n      }\n      startEarningPointsButton {\n        ...EGDSButtonFragment\n      }\n      justEnrolledButton {\n        ...EGDSButtonFragment\n      }\n      justEnrolledPopOver {\n        heading\n        paragraph\n      }\n      tierCards {\n        ...RewardsTierCardsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
import React11 from "react";
import { gql as gql14, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
// ../internal/src/components/common/client-side-analytics.ts
import { gql } from "@apollo/client";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
import { gql as gql2 } from "@apollo/client";
var _obj;
// ../internal/src/components/common/uitk-link-target-mapper.tsx
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// ../internal/src/components/ui-link-action/lodging-ui-link-action.ts
var fragment = gql2(_templateObject1());
var getUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getUILinkActionTarget = function(action) {
    return UILinkTargetMap[action.target];
};
// ../internal/src/components/egds-button/egds-button.tsx
var fragment2 = gql3(_templateObject2(), fragment, clientSideAnalyticsFragment);
var deriveLinkProps = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton,
    UITertiaryButton: UitkTertiaryButton
};
var EGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var linkProps = deriveLinkProps(action);
    var track = useClickTracker();
    var handleClick = React.useCallback(function(event) {
        var _onClick;
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        analytics,
        onClick,
        track
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, disabled ? {} : linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), primary);
    }
    return null;
};
EGDSButton.fragment = fragment2;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/egds-text/egds-text.tsx
import React4 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React2 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj1;
// ../internal/src/components/common/link-map.tsx
var linkSizeMapper = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */ , "small"), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj1, "LARGE" /* LARGE */ , "large"), _obj1);
var _obj2;
var UILinkTargetMap2 = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self"), _obj2);
// ../internal/src/components/egds-text/__private/link-action.tsx
import { gql as gql4 } from "@apollo/client";
var UILinkActionFragment = gql4(_templateObject3());
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment3 = gql5(_templateObject4(), UILinkActionFragment);
var EGDSStandardLink = function(param) {
    var className = param.className, inline = param.inline, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker2();
    var onClick = React2.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React2.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: inline
    }, /* @__PURE__ */ React2.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap2[target]
    }, text, accessibility && /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment3;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React3 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var _obj3;
// ../internal/src/components/common/text-utils.tsx
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _obj3);
var _obj4;
var textWeightMapper = (_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */ , "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment4 = gql6(_templateObject5());
var EGDSStylizedText = function(param) {
    var _param_data = param.data, text = _param_data.text, weight = _param_data.weight, theme = _param_data.theme, size = param.size, inline = param.inline;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    return /* @__PURE__ */ React3.createElement(UitkText, {
        weight: weightProps,
        size: size,
        inline: inline,
        theme: themeProps
    }, text);
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment5 = gql7(_templateObject6(), EGDSStylizedText.fragment, EGDSStandardLink.fragment);
var EGDSText = function(param) {
    var data = param.data, size = param.size, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React4.createElement(EGDSStylizedText, {
                data: data,
                size: size,
                inline: inline
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React4.createElement(EGDSStandardLink, {
                className: className,
                data: data,
                inline: inline
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment5;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/ui-graphic/icon.tsx
import React5 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment6 = gql8(_templateObject7());
var _data_theme;
var Icon = function(param) {
    var data = param.data, size = param.size, spotlight = param.spotlight;
    return /* @__PURE__ */ React5.createElement(UitkIcon, {
        id: data.id,
        name: data.token,
        size: size !== null && size !== void 0 ? size : UitkIconSize.MEDIUM,
        theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        spotlight: spotlight
    });
};
Icon.displayName = "Icon";
Icon.fragment = fragment6;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React6 from "react";
import { gql as gql9 } from "@apollo/client";
var fragment7 = gql9(_templateObject8(), Icon.fragment);
var UIGraphic = function(param) {
    var data = param.data, iconOptions = param.iconOptions;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React6.createElement(Icon, _object_spread({
                data: data
            }, iconOptions));
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment7;
// src/components/rewards/rewards.tsx
import { UitkHeading } from "uitk-react-text";
// src/components/rewards/__private/components/__fragments/rewards-enrolled-members.tsx
import React8 from "react";
import { gql as gql11 } from "@apollo/client";
var _obj5;
// ../internal/src/components/common/icon-utils.tsx
var spotlightMapper = (_obj5 = {}, _define_property(_obj5, "emphasis" /* emphasis */ , "info"), _define_property(_obj5, "positive" /* positive */ , "positive"), _define_property(_obj5, "negative" /* negative */ , "warning"), _define_property(_obj5, "default" /* default */ , "standard"), _define_property(_obj5, "inverse" /* inverse */ , "standard"), _obj5);
// src/components/rewards/__private/components/__fragments/rewards-enrolled-members.tsx
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard2, UitkCardContentSection } from "uitk-react-cards";
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
// src/components/rewards/__private/components/__fragments/rewards-enrolled-members-tier-cards.tsx
import React7 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkCard, UitkCardBackgroundThemes } from "uitk-react-cards";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSheet, UitkSheetCloseButton, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var retailTravelAgentTierCardsFragment = gql10(_templateObject9(), Icon.fragment, EGDSStylizedText.fragment, EGDSStandardLink.fragment, fragment, EGDSButton.fragment);
var RetailTravelAgentTierCards = function(param) {
    var card = param.data, type = param.type;
    var spotlight = card.descriptionPoints.theme ? spotlightMapper[card.descriptionPoints.theme] : void 0;
    var _React7_useState = _sliced_to_array(React7.useState(false), 2), visible = _React7_useState[0], setVisible = _React7_useState[1];
    var triggerRef = React7.useRef(null);
    var toggleVisibility = function() {
        setVisible(!visible);
    };
    var renderSheet = function(param) {
        var typeOfDisplay = param.type, width = param.width, maxHeight = param.maxHeight;
        var sheetWidth = width || 300;
        var sheetHeight = maxHeight || 10;
        return /* @__PURE__ */ React7.createElement(UitkLayoutPosition, {
            type: "relative"
        }, /* @__PURE__ */ React7.createElement(UitkMoreInfoTrigger, {
            onClick: toggleVisibility
        }, /* @__PURE__ */ React7.createElement("span", null, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
            alignItems: "center",
            space: "one"
        }, /* @__PURE__ */ React7.createElement(EGDSText, {
            data: card.descriptionPoints,
            size: 400
        }), /* @__PURE__ */ React7.createElement(UIGraphic, {
            data: card.infoIcon,
            iconOptions: {
                spotlight: spotlight,
                size: card.infoIcon.size ? UitkIconSize2[card.infoIcon.size] : void 0
            }
        })))), /* @__PURE__ */ React7.createElement(UitkLayoutPosition, {
            display: "block",
            position: {
                left: "minus-half",
                top: "six"
            },
            type: "absolute",
            pointerEvents: "none"
        }, /* @__PURE__ */ React7.createElement(UitkSheet, {
            isVisible: visible,
            type: typeOfDisplay,
            triggerRef: triggerRef,
            onDismiss: toggleVisibility,
            width: sheetWidth,
            maxHeight: sheetHeight
        }, /* @__PURE__ */ React7.createElement(UitkSheetCloseButton, null, /* @__PURE__ */ React7.createElement(UitkTertiaryButton2, {
            onClick: toggleVisibility
        }, /* @__PURE__ */ React7.createElement(UitkIcon2, {
            name: "close",
            size: UitkIconSize2.MEDIUM
        }))), /* @__PURE__ */ React7.createElement(UitkSheetContent, null, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
            direction: "column",
            alignItems: "start",
            space: "two"
        }, card.moreInfoPopOver && /* @__PURE__ */ React7.createElement(UitkText2, {
            size: 400,
            weight: "bold"
        }, card.moreInfoPopOver.heading), card.moreInfoPopOver && /* @__PURE__ */ React7.createElement(UitkText2, {
            size: 300,
            align: "left"
        }, card.moreInfoPopOver.paragraph))))));
    };
    return /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, {
        grow: 1,
        key: card.id
    }, /* @__PURE__ */ React7.createElement(UitkSpacing, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React7.createElement(UitkCard, {
        backgroundTheme: UitkCardBackgroundThemes[card.background],
        key: card.id,
        overflow: true
    }, /* @__PURE__ */ React7.createElement(UitkText2, {
        align: "center"
    }, card.headingPoints && /* @__PURE__ */ React7.createElement(EGDSText, {
        data: card.headingPoints,
        size: 700
    }), card.descriptionPoints && card.infoIcon && /* @__PURE__ */ React7.createElement(UitkSpacing, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        justifyContent: "center",
        alignItems: "start",
        space: "one"
    }, renderSheet({
        type: type
    }))), card.descriptionPointsValue && /* @__PURE__ */ React7.createElement(UitkSpacing, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        justifyContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React7.createElement(EGDSText, {
        data: card.descriptionPointsValue,
        size: 300
    }))), /* @__PURE__ */ React7.createElement(UitkSpacing, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        justifyContent: "center"
    }, card.token === "primary" ? card.redeemYourPointsButton && /* @__PURE__ */ React7.createElement(EGDSButton, {
        data: card.redeemYourPointsButton
    }) : null))))));
};
RetailTravelAgentTierCards.displayName = "RetailTravelAgentTierCards";
RetailTravelAgentTierCards.fragment = retailTravelAgentTierCardsFragment;
// src/components/rewards/__private/components/__fragments/rewards-enrolled-members.tsx
var rewardsEnrolledViewFragment = gql11(_templateObject10(), RetailTravelAgentTierCards.fragment, Icon.fragment, EGDSStylizedText.fragment, EGDSStandardLink.fragment);
var RewardsEnrolledView = function(param) {
    var data = param.data;
    var _data_icon, _data_icon1, _data_tierCards, _data_tierCards1;
    var spotlight = ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.theme) ? spotlightMapper[(_data_icon1 = data.icon) === null || _data_icon1 === void 0 ? void 0 : _data_icon1.theme] : void 0;
    return /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React8.createElement(UitkCard2, {
        border: true,
        overflow: true
    }, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        padding: {
            inlinestart: "six",
            inlineend: "six",
            blockstart: "two",
            blockend: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutGrid, {
        space: "two"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React8.createElement(UitkCard2, {
        key: data.heading.text,
        overflow: true
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, {
        alignContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
        grow: 1,
        minWidth: 150,
        maxWidth: 405
    }, data.icon && /* @__PURE__ */ React8.createElement(UIGraphic, {
        data: data.icon,
        iconOptions: {
            spotlight: spotlight,
            size: data.icon.size ? UitkIconSize3[data.icon.size] : void 0
        }
    })), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
        grow: 2,
        minWidth: 150,
        alignSelf: "start"
    }, /* @__PURE__ */ React8.createElement(UitkCardContentSection, null, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, {
        direction: "column"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, null, data.heading && /* @__PURE__ */ React8.createElement(EGDSText, {
        data: data.heading,
        size: 500
    })), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
        maxWidth: 640
    }, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkText3, {
        size: 400
    }, data.paragraph.text, " ", data.inLineLink && /* @__PURE__ */ React8.createElement(EGDSText, {
        data: data.inLineLink,
        inline: true
    })))))))), /* @__PURE__ */ React8.createElement(Viewport, null, /* @__PURE__ */ React8.createElement(ViewLarge, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, null, (_data_tierCards = data.tierCards) === null || _data_tierCards === void 0 ? void 0 : _data_tierCards.map(function(card, index) {
        return /* @__PURE__ */ React8.createElement(RetailTravelAgentTierCards, {
            data: card,
            key: index,
            type: "popover"
        });
    })))), /* @__PURE__ */ React8.createElement(ViewSmall, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, {
        direction: "column"
    }, (_data_tierCards1 = data.tierCards) === null || _data_tierCards1 === void 0 ? void 0 : _data_tierCards1.map(function(card, index) {
        return /* @__PURE__ */ React8.createElement(RetailTravelAgentTierCards, {
            data: card,
            key: index,
            type: "popover"
        });
    }))))), data.refreshedAt && /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React8.createElement(EGDSText, {
        data: data.refreshedAt,
        size: 200
    }))))), /* @__PURE__ */ React8.createElement(UitkLayoutGridItem, null)))));
};
RewardsEnrolledView.displayName = "RewardsEnrolledView";
RewardsEnrolledView.fragment = rewardsEnrolledViewFragment;
// src/components/rewards/__private/components/__fragments/rewards-non-enrolled-members.tsx
import React10 from "react";
import { gql as gql13 } from "@apollo/client";
import { ViewLarge as ViewLarge2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// src/components/rewards/__private/components/__fragments/rewards-non-enrolled-members-popover.tsx
import React9 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSheet as UitkSheet2, UitkSheetCloseButton as UitkSheetCloseButton2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkParagraph, UitkText as UitkText4 } from "uitk-react-text";
var rewardsNonEnrolledMembersPopoverFragment = gql12(_templateObject11(), EGDSButton.fragment);
var RewardsNonEnrolledMembersPopover = function(param) {
    var data = param.data;
    var _React9_useState = _sliced_to_array(React9.useState(false), 2), visible = _React9_useState[0], setVisible = _React9_useState[1];
    var triggerRef = React9.useRef(null);
    var toggleVisibility = function() {
        setVisible(!visible);
    };
    var renderSheet = function(param) {
        var type = param.type, width = param.width;
        var sheetWidth = width || 350;
        return /* @__PURE__ */ React9.createElement(UitkLayoutPosition2, {
            type: "relative"
        }, data.justEnrolledButton && /* @__PURE__ */ React9.createElement(EGDSButton, {
            data: data.justEnrolledButton,
            onClick: toggleVisibility
        }), /* @__PURE__ */ React9.createElement(UitkLayoutPosition2, {
            display: "block",
            position: {
                bottom: "minus-one"
            },
            type: "absolute",
            pointerEvents: "none"
        }, /* @__PURE__ */ React9.createElement(UitkSheet2, {
            isVisible: visible,
            type: type,
            triggerRef: triggerRef,
            onDismiss: toggleVisibility,
            width: sheetWidth
        }, /* @__PURE__ */ React9.createElement(UitkSheetCloseButton2, null, /* @__PURE__ */ React9.createElement(UitkTertiaryButton3, {
            onClick: toggleVisibility
        }, /* @__PURE__ */ React9.createElement(UitkIcon3, {
            name: "close",
            size: UitkIconSize4.MEDIUM
        }))), /* @__PURE__ */ React9.createElement(UitkSheetContent2, {
            padded: true
        }, data.justEnrolledPopOver && /* @__PURE__ */ React9.createElement(UitkText4, {
            size: 500,
            weight: "bold"
        }, data.justEnrolledPopOver.heading), data.justEnrolledPopOver && /* @__PURE__ */ React9.createElement(UitkParagraph, null, data.justEnrolledPopOver.paragraph)))));
    };
    return renderSheet({
        type: "popover"
    });
};
RewardsNonEnrolledMembersPopover.displayName = "RewardsNonEnrolledMembersPopover";
RewardsNonEnrolledMembersPopover.fragment = rewardsNonEnrolledMembersPopoverFragment;
// src/components/rewards/__private/components/__fragments/rewards-non-enrolled-members.tsx
var rewardsNonEnrolledViewFragment = gql13(_templateObject12(), EGDSStylizedText.fragment, EGDSStandardLink.fragment, RewardsNonEnrolledMembersPopover.fragment, EGDSButton.fragment);
var RewardsNonEnrolledView = function(param) {
    var data = param.data;
    var renderNonEnrolledView = function(param) {
        var type = param.type;
        var _data_image, _data_image1;
        return /* @__PURE__ */ React10.createElement(UitkSpacing3, {
            margin: {
                blockstart: "six"
            }
        }, /* @__PURE__ */ React10.createElement(UitkCard3, {
            overflow: true,
            border: true
        }, /* @__PURE__ */ React10.createElement(UitkLayoutGrid2, {
            columns: type === "mobile" ? 1 : 12,
            display: "grid",
            alignItems: "center",
            space: "two"
        }, /* @__PURE__ */ React10.createElement(UitkLayoutGridItem2, {
            colSpan: type === "mobile" ? 12 : 3
        }, /* @__PURE__ */ React10.createElement(UitkFigure, {
            className: type === "mobile" ? "uitk-card-roundcorner-top-left uitk-card-roundcorner-top-right" : "uitk-card-roundcorner-top-left uitk-card-roundcorner-bottom-left"
        }, /* @__PURE__ */ React10.createElement(UitkImage, {
            alt: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
            blankDefault: false,
            placeholderImage: true,
            src: (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url
        }))), /* @__PURE__ */ React10.createElement(UitkLayoutGridItem2, {
            colSpan: type === "mobile" ? 12 : 9
        }, /* @__PURE__ */ React10.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex3, {
            direction: "column"
        }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, data.heading && /* @__PURE__ */ React10.createElement(EGDSText, {
            data: data.heading,
            size: 500
        })), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, {
            maxWidth: 640
        }, /* @__PURE__ */ React10.createElement(UitkSpacing3, {
            padding: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React10.createElement(UitkText5, {
            size: 400
        }, data.paragraph.text, " ", data.inLineLink && /* @__PURE__ */ React10.createElement(EGDSText, {
            data: data.inLineLink,
            inline: true
        }))))), /* @__PURE__ */ React10.createElement(UitkSpacing3, {
            padding: {
                blockstart: "four"
            }
        }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex3, {
            space: "four",
            justifyContent: type === "mobile" ? "center" : "start"
        }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, data.startEarningPointsButton && /* @__PURE__ */ React10.createElement(EGDSButton, {
            data: data.startEarningPointsButton
        })), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React10.createElement(RewardsNonEnrolledMembersPopover, {
            data: data
        })))))))));
    };
    return /* @__PURE__ */ React10.createElement(Viewport2, null, /* @__PURE__ */ React10.createElement(ViewLarge2, null, renderNonEnrolledView({
        type: "desktop"
    })), /* @__PURE__ */ React10.createElement(ViewSmall2, null, renderNonEnrolledView({
        type: "mobile"
    })));
};
RewardsNonEnrolledView.displayName = "RewardsNonEnrolledView";
RewardsNonEnrolledView.fragment = rewardsNonEnrolledViewFragment;
// src/components/rewards/rewards.tsx
var __Query = gql14(_templateObject13(), RetailTravelAgentTierCards.fragment, Icon.fragment, EGDSStylizedText.fragment, EGDSStandardLink.fragment, fragment, EGDSButton.fragment);
var Rewards = function(props) {
    var _data;
    var skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !((_data = data) === null || _data === void 0 ? void 0 : _data.retailTravelAgentRewards)) {
        return null;
    }
    var _data_retailTravelAgentRewards = data.retailTravelAgentRewards, title = _data_retailTravelAgentRewards.title, rewardsProgramState = _data_retailTravelAgentRewards.rewardsProgramState;
    return /* @__PURE__ */ React11.createElement("div", null, title && /* @__PURE__ */ React11.createElement(UitkHeading, {
        size: 3,
        tag: "h2"
    }, title), rewardsProgramState === "NOT_ENROLLED" /* NOT_ENROLLED */  ? /* @__PURE__ */ React11.createElement(RewardsNonEnrolledView, {
        data: data.retailTravelAgentRewards
    }) : /* @__PURE__ */ React11.createElement(RewardsEnrolledView, {
        data: data.retailTravelAgentRewards
    }));
};
Rewards.displayName = "sharedui-Rewards";
export { Rewards };
//# sourceMappingURL=index.js.map